import React from "react";
import { Card, Row, Col, Button } from "antd";
import "./AssignmentCard.less";

const AssignmentCard = ({ subjectName, postedOn, dueDate, onClick, time }) => {
  return (
    <Card className='assignment-card'>
      <Row>
        <Col span={18}>
          <div className='info-row'>
            <div span={12}>
              <div className='info-label'>Subject name</div>
              <div className='info-value'>{subjectName}</div>
            </div>
            <div span={12}>
              <div className='info-label'>Posted on</div>
              <div className='info-value'>{postedOn}</div>
            </div>
          </div>
          <div className='info-row'>
            <div span={12}>
              <div className='info-label'>Due Date</div>
              <div className='info-value'>
                {dueDate} | {time}
              </div>
            </div>
            <div span={8} className='view-button-container'>
              <Button type='primary' className='view-button' onClick={onClick}>
                View
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default AssignmentCard;
